<div class="main-page-layout">
  <section id="discover-us">
    <discover-us></discover-us>
  </section>
  <section id="about-us">
    <customer-about-us></customer-about-us>
  </section>
  <section id="featured-chefs">
    <featured-chefs></featured-chefs>
  </section>
  <section id="meals">
    <meals></meals>
  </section>
  <section id="popular-dishes">
    <popular-dishes></popular-dishes>
  </section>
  <section id="choose-us">
    <choose-us></choose-us>
  </section>
  <section id="stay-connected">
    <stay-connected></stay-connected>
  </section>
</div>
